import { QueryClient } from '@tanstack/react-query';

import { isAppError } from '@/lib/result';

/**
 * Shared React Query client. Server state lives here (instructions/02_ARCHITECTURE.md).
 * We don't retry authorization failures — they won't succeed on retry.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          if (
            isAppError(error) &&
            (error.code === 'not-authorized' || error.code === 'not-found')
          ) {
            return false;
          }
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
